import React from "react";
import Card from "@material-ui/core/Card";
import GraphDataCard from "./GraphDataCard";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";

import "./GraphDataCards.scss";

const useStyles = makeStyles({
  root: {
    background: "rgba(67, 71, 91, 0.25)",
    minHeight: "75px",
    width: "200px",
    "@media only screen and (min-width: 950px)": {
      width: "255px"
    },
    "@media only screen and (max-height: 1075px)": {
      minHeight: "0"
    }
  }
});

const GraphDataCardPane = ({ modelPoint, queriedData, selectedGraph }) => {
  const classes = useStyles();
  const { spotter } = queriedData;

  const graphStore = {
    wave: {
      name: {
        significantWaveHeight: "wave height"
      },
      graph: ["significantWaveHeight"],
      measurement: "m",
      toFixed: 2
    },
    period: {
      name: {
        peakPeriod: "peak period",
        meanPeriod: "mean period"
      },
      graph: ["peakPeriod", "meanPeriod"],
      measurement: "s",
      toFixed: 2
    },
    direction: {
      name: {
        peakDirection: "peak direction",
        meanDirection: "mean direction"
      },
      graph: ["peakDirection", "meanDirection"],
      measurement: "°",
      toFixed: 1
    },
    spread: {
      name: {
        peakDirectionalSpread: "peak spread",
        meanDirectionalSpread: "mean spread"
      },
      graph: ["peakDirectionalSpread", "meanDirectionalSpread"],
      measurement: "°",
      toFixed: 1
    }
  };

  const colorStore = ["#E3C734", "rgba(183,76,164,1)"];

  return (
    <div id="graph-data-card-pane" className="graph-data-card-pane">
      <Grid container spacing={2}>
        {spotter &&
          graphStore[selectedGraph].graph.map((ele, index) => (
            <Grid key={ele} item>
              <Card className={classes.root}>
                <GraphDataCard
                  color={colorStore[index]}
                  data={`${spotter[ele].toFixed(
                    graphStore[selectedGraph].toFixed
                  )}${graphStore[selectedGraph].measurement}`}
                  dataType={`${graphStore[selectedGraph].name[ele]} observations`}
                />
              </Card>
            </Grid>
          ))}
        <Grid item>
          <Card className={classes.root}>
            {selectedGraph === "wave" ? (
              <GraphDataCard
                color="#EA6B72"
                data={`${modelPoint.value.toFixed(
                  graphStore[selectedGraph].toFixed
                )}${graphStore[selectedGraph].measurement}`}
                dataType="wave height mean model"
              />
            ) : (
              <GraphDataCard
                color="#EA6B72"
                data={`${modelPoint.value.toFixed(
                  graphStore[selectedGraph].toFixed
                )}${graphStore[selectedGraph].measurement}`}
                dataType={`mean ${selectedGraph} model`}
              />
            )}
          </Card>
        </Grid>
      </Grid>
    </div>
  );
};

export default GraphDataCardPane;
